module.exports = __webpack_public_path__ + "static/media/sar.7aefbfb0.gif";